import React, { useEffect } from 'react'
import { callNativeByParams, getUA } from '@penguin/utils'
const ua = getUA()
const LINKS = {
  card: 'https://xlh.saiqun.top/h5/index?shua=1',
  zero: 'https://h5user.qiekj.com/integral/VipShop',
  store: 'https://h5user.qiekj.com/integral/store',
}

const Collection = () => {
  useEffect(() => {
    document.title = '3分钟怒赚价值百元'
  }, [])
  return (
    <div>
      <div className='absolute top-0 left-0 w-full' style={{ fontSize: 0 }}>
        <img src='https://static.qiekj.com/static/web/image/shengqian_gonglv_bg_01.jpg' alt='' />
        <img src='https://static.qiekj.com/static/web/image/shengqian_gonglv_bg_02.jpg' alt='' />
        <img src='https://static.qiekj.com/static/web/image/shengqian_gonglv_bg_03.jpg' alt='' />
      </div>
      <div className='relative flex flex-col items-center'>
        <div
          onClick={() => {
            if (ua === 'app') {
              callNativeByParams('jumpNativePage', {
                url: LINKS.card,
              })
            } else {
              window.location.href = LINKS.card
            }
          }}
          className='rem:mt-[2610px] p-8 pl-32 pr-32'
        ></div>
        <div
          onClick={() => {
            if (ua === 'app') {
              callNativeByParams('jumpNativePage', {
                url: LINKS.zero,
              })
            } else {
              window.location.href = LINKS.zero
            }
          }}
          className='rem:mt-[1570px] p-8 pl-32 pr-32'
        ></div>
        <div
          onClick={() => {
            if (ua === 'app') {
              callNativeByParams('jumpNativePage', {
                url: LINKS.store,
              })
            } else {
              window.location.href = LINKS.store
            }
          }}
          className='rem:mt-[1730px] p-8 pl-32 pr-32'
        ></div>
      </div>
    </div>
  )
}

export default Collection
